<script setup lang="ts">
import type { SessionsCatalogRowResponse } from "@simbelapp/order-sdk";
import SimpleTable from "~/components/Common/Tables/SimpleTable.vue";
import Tag from "~/components/Common/Tag.vue";
import { useFormats } from "~/composables/utils/useFormat";
import { useTrainingCatalogSessions } from "~/composables/trainings/useTrainingCatalogSessions";

defineProps<{ rows: SessionsCatalogRowResponse[] }>();

defineSlots<{
  /** Trailing cell: opening the session in the plan, or dropping a date that is not in it yet. */
  action(props: { row: SessionsCatalogRowResponse }): any;
}>();

const { catalogSessionHeaders, sessionTypeTag, sessionCapacity } = useTrainingCatalogSessions();
const format = useFormats();
</script>

<template>
  <SimpleTable :headers="catalogSessionHeaders" :rows="rows" track-by="sessionId" :expand-first-column="false">
    <template #row="{ row }">
      <td>
        <span class="body_regular text-primary-color">{{ format.toDateDisplay(row.startDate) }}</span>
      </td>
      <td>
        <span class="body_regular text-primary-color">{{ format.toDateDisplay(row.endDate) }}</span>
      </td>
      <td>
        <Tag :tag="sessionTypeTag(row)" />
      </td>
      <td>
        <span class="body_regular text-primary-color">{{ sessionCapacity(row) }}</span>
      </td>
      <td>
        <span class="body_regular text-primary-color">{{ row.location || "À définir" }}</span>
      </td>
      <td class="cell-right">
        <div class="flex justify-end">
          <slot name="action" :row="row" />
        </div>
      </td>
    </template>
  </SimpleTable>
</template>
